import { z } from 'zod'

/** The inbox's tabs; "Waiting for me" is the default (no `tab` in the URL). */
export const APPROVAL_TABS = ['waiting', 'submitted', 'completed', 'delegations'] as const
export type ApprovalTab = (typeof APPROVAL_TABS)[number]

export const approvalsSearchSchema = z.object({
  tab: z.enum(['submitted', 'completed', 'delegations']).optional().catch(undefined),
  page: z.coerce.number().int().min(2).optional().catch(undefined),
})
export type ApprovalsSearch = z.infer<typeof approvalsSearchSchema>

/**
 * A request page remembers where it was opened from (the inbox tab, so Back returns there) and,
 * from the inbox or a document, which task of the viewer's it is about.
 */
export const approvalRequestSearchSchema = z.object({
  task: z.uuid().optional().catch(undefined),
  from: z.enum(['submitted', 'completed', 'delegations']).optional().catch(undefined),
})
export type ApprovalRequestSearch = z.infer<typeof approvalRequestSearchSchema>
